export default __webpack_public_path__ + "static/media/tableau-de-bord.bb602582.svg";